module.exports = __webpack_public_path__ + "img/kompetenz_logo_2016_neg.11e78fc6.svg";